import { UseDeleteManyItemsProps } from '@/presentation/common/hooks/crud/v2/types.ts'
import { UiStateStatus, useUiStatus } from '@/presentation/common/hooks/useUiStatus.ts'
import { errorHandler } from '@/presentation/common/utils/errorHandler.ts'

export const useDeleteManyItems = <TRequest, TResponse>({
  messages,
  callable,
}: UseDeleteManyItemsProps<TRequest, TResponse>) => {
  const status = useUiStatus()

  const submit = async (req: TRequest) => {
    status.resetStatus()

    try {
      status.setStatus(UiStateStatus.LOADING)
      status.setMessage(messages.loading ?? 'Cargando')

      const response = await callable(req)

      status.setStatus(UiStateStatus.SUCCESS)
      status.setMessage(messages.success ?? 'Eliminación exitosa')
      return response as TResponse
    }
    catch (error) {
      const message = errorHandler({
        error,
        messages: messages,
      })

      status.setStatus(UiStateStatus.ERROR)
      status.setMessage(message)
    }
  }

  return {
    message   : status.message,
    isLoading : status.isLoading,
    isSuccess : status.isSuccess,
    isError   : status.isError,
    submit,
  }
}
